module.exports = __webpack_public_path__ + "img/image86.b821f716.jpg";